import { useMutation } from "@tanstack/react-query"
import instance from "../instance"

export const useLogin=()=>{
    const mutation= useMutation(async(payload)=>{
        const {data}= await instance.post(`/api/login`, payload)
        if(data?.user?.role !=="admin"){
throw ({response:{data:{message:"User role not an admin"}}})
        }
        return data
    })
    return mutation
}